module.exports = __webpack_public_path__ + "static/img/20-清华大学附属中学永丰学校东校区.b22031b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/20-清华大学附属中学永丰学校东校区.png
// module id = rdQI
// module chunks = 0